import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Component from 'decorators/Component'
import Div from 'components/Div'
import Flex from 'components/Flex'
import DivButton from 'components/DivButton'
import { H4 } from 'components/Typo'
import IconClose from 'components/Icons/IconClose'
import { NotificationIcon, Notification } from 'components/InlineNotification'
import toast from 'components/Toast'
import { states as notificationStates, iconSizes, paddingSizes, marginSizes, borderRadiusSizes, dropShadowVariations } from 'theme/default'

const ToastNotificationContainer = styled(Div).attrs(() => ({
  marginBottom: marginSizes.medium,
  padding: paddingSizes.medium,
  borderRadius: borderRadiusSizes.medium,
  boxShadow: dropShadowVariations.heavy
}))`
  overflow: hidden;
  background-color: ${props => props.backgroundColor};
  color: ${props => props.color};
`
ToastNotificationContainer.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
}

const StyledNotificationIcon = styled(NotificationIcon)`
  align-items: center;
`

const ToastNotificationComponent = ({ t, closeToast, state, text, lightTheme }) => (
  <Notification state={state} lightTheme={lightTheme}>
    {({ color, backgroundColor, Icon }) => (
      <ToastNotificationContainer color={color} backgroundColor={backgroundColor}>
        <Flex justifyContent='flex-start' alignItems='flex-start'>
          <StyledNotificationIcon Icon={Icon} fillColor={color} iconSize={iconSizes.large} />
          <Flex flexDirection='column' flexGrow={1}>
            <H4 normalised bold color={color}>
              {typeof text === 'function' ? text({ t }) : text}
            </H4>
          </Flex>
          <Flex alignItems='flex-start' flexShrink={0} >
            <DivButton onClick={closeToast}>
              <IconClose fill={color} iconSize={iconSizes.medium} />
            </DivButton>
          </Flex>
        </Flex>
      </ToastNotificationContainer>
    )}
  </Notification>
)
ToastNotificationComponent.propTypes = {
  t: PropTypes.func.isRequired,
  closeToast: PropTypes.func,
  state: PropTypes.string,
  text: PropTypes.string,
  lightTheme: PropTypes.bool
}
ToastNotificationComponent.defaultProps = {
  state: notificationStates.informative
}

export const ToastNotification = Component()(ToastNotificationComponent)

export { notificationStates }

const showNotificationToast = (props) => toast(<ToastNotification {...props} />, { slideInAnimation: 'right', closeOnClick: true, duration: 2000 })

Object.keys(notificationStates).forEach((key) => {
  showNotificationToast[key] = (text) => showNotificationToast({ text, state: notificationStates[key] })
})

export default showNotificationToast
